import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Grid2 } from '@mui/material';

import { ROUTES } from 'core/routing/routes';

import Layout from 'components/Layout';

import { ScheduleService } from 'core/api/services/schedule';

import { useTranslation } from 'core/contexts/localization';
import { useAuth } from 'core/contexts/auth';
import { useExperiences } from 'core/contexts/experience';
import { useBookings } from 'core/contexts/booking';
import { useExperiencers } from 'core/contexts/experiencer';
import { ExperienceResourceService } from 'core/api/services/ExperienceInfo/expResource';
import { useStyles } from './styles';
import CheckoutPageComponent from 'components/CheckoutPageLegacy';

import { ResourceGrid, ExperienceAvailabilityLegacy, AlertDialog, formatDateToYYYYMMDD } from '@utriper/core-ui';
import { ExperienceStatus } from '@utriper/core';

const BookingNew = () => {
    const { t: translate } = useTranslation();
    const classes = useStyles();
    const history = useHistory();

    const { experiences, getExperiencesUpdated, setTimeOfArrival, contractExperiences, contractBundleExperiences, getContractExperiences, getContractBundleExperiences, getExperienceTermsId } = useExperiences();
    const { contract, contracts, getContracts, setContract } = useExperiencers();

    // const [onFirstCall, _] = useState(true);
    const [experiencerName, setExperiencerName] = useState([]); // This is used for dropdown display and selection
    const [allExpAndBundles, setAllExpAndBundles] = useState([]); // This is used for dropdown display and selection
    const [quantity, setQuantity] = useState(1);
    const [selectedExperienceItem, setSelectedExperienceItem] = useState(null);
    const [experienceDetailOptions, setExperienceDetailOptions] = useState([]);
    const [experienceDetail, setExperienceDetail] = useState(null);
    const [schedule, setSchedules] = useState();
    const [dateDatePicker, setDateDatePicker] = useState(new Date());
    const [selectedSlot, setSelectedSlot] = useState(null);
    // const [showErrorPrice, setShowErrorPrice] = useState(false);
    // const [checkoutId, setCheckoutId] = useState(0);
    const [categoriesData, setCategoriesData] = useState();
    const [rawDataCategories, setRawDataCategories] = useState();
    const [scheduleDate, setScheduleDate] = useState(() => formatDateToYYYYMMDD(new Date()));

    const { checkoutItems, setCheckoutItems, addCheckoutItem, addBooking, addContractBookingPayment, deleteContractBookingPayment, cancelStatusPaymentLink, notifyPaymentLink } = useBookings();

    const [openAvailabilityModal, setOpenAvailabilityModal] = useState(false);
    const [openResourcesModal, setOpenResourcesModal] = useState(false); // This is use only on override

    const handleChangeDetails = (options, expDetail) => {
        setExperienceDetailOptions(options);
        setExperienceDetail(expDetail);
    };

    const handleSetExpDetail = (newExpDetail) => {
        setExperienceDetail(newExpDetail);
        setSelectedSlot({ ...selectedSlot, experienceDetailId: newExpDetail?.id });
    };

    const handleClickAvailabilityModal = () => {
        setSelectedSlot(null);
        setResourceSelected([]);
        setOpenAvailabilityModal(true);
    };
    const handleClickResourcesModal = () => {
        setResourceSelected([]);
        setOpenResourcesModal(true);
    };

    const onCloseAvailabilityModal = () => {
        setOpenAvailabilityModal(false);
    };
    const onCloseResourcesModal = () => {
        setOpenResourcesModal(false);
    };

    const [bookingId, setBookingId] = useState(null);
    const [bookingCode, setBookingCode] = useState(null);
    const [successOpen, setSuccessOpen] = useState(false);
    const [resourceSelected, setResourceSelected] = useState([]);
    const [loading, setLoading] = useState(false);
    const [visibleRange, setVisibleRange] = useState({
        start: null,
        end: null,
    });
    const handleModalSuccess = () => {
        setSuccessOpen(true);
    };

    const { getUserInfoSync } = useAuth();

    useEffect(() => {
        if (openAvailabilityModal && Date.parse(visibleRange.start) && Date.parse(visibleRange.end)) {
            setLoading(true);

            ScheduleService.getAvailability({
                expId: selectedExperienceItem.experienceId,
                experienceDetailId: experienceDetail?.id ?? null,
                fromDateTime: new Date(visibleRange.start),
                toDateTime: new Date(visibleRange.end),
                groupSize: quantity,
                code: contract && contract.id ? contract.id.toString(16) : 0,
                resources: resourceSelected,
            }).then((res) => {
                setSchedules([...res]);
                setLoading(false);
            });
        }
    }, [scheduleDate, selectedExperienceItem, experienceDetail, quantity, resourceSelected, openAvailabilityModal, visibleRange]);

    const listExperiences = () => {
        // if (onFirstCall) {
        const auxCheckout = [];
        setCheckoutItems(auxCheckout);
        setTimeOfArrival(null);
        setSelectedExperienceItem(null);
        // }

        const allExp = [];
        let uniqueId = 0;
        if (experiences && experiences.length) {
            experiences.forEach((exp) => {
                allExp.push({
                    ...exp,
                    experiencer: experiencerName,
                    experienceId: exp.id,
                    id: uniqueId,
                    expDetailId: exp.experienceDetailId,
                });
                uniqueId++;
            });
        }
        setAllExpAndBundles(allExp);
    };
    useEffect(() => {
        listExperiences();
    }, [experiences]);

    const handleSelectContract = async (contract) => {
        setSelectedSlot(null);
        setQuantity(1);
        setResourceSelected([]);
        if (contract && contract.id) {
            setAllExpAndBundles([]);
            setContract(contract);
            await getContractExperiences(contract.id);
            await getContractBundleExperiences(contract.id);
        } else {
            setContract({});
            listExperiences();
        }
    };
    useEffect(() => {
        setCheckoutItems([]);
        setTimeOfArrival(null);
        setSelectedExperienceItem(null);

        const allExp = [];
        let uniqueId = 0;
        if (contractExperiences && contractExperiences.length) {
            contractExperiences.forEach((exp) => {
                allExp.push({
                    ...exp,
                    experiencer: experiencerName,
                    experienceId: exp.id,
                    id: uniqueId,
                    expDetailId: exp.experienceDetailId,
                });
                uniqueId++;
            });
        }
        if (contractBundleExperiences && contractBundleExperiences.length) {
            contractBundleExperiences.forEach((bld) => {
                bld.experiences?.forEach((exp) => {
                    exp.expDetailId = exp.id;
                    exp.experienceId = exp.expId;
                    exp.id = uniqueId;
                    uniqueId++;
                });
                const statusFilter = bld.experiences.filter((exp) => {
                    return exp.expStatus == ExperienceStatus.IDS.live;
                });
                if (statusFilter.length) {
                    allExp.push({
                        ...bld,
                        experiences: statusFilter,
                        name: `${translate('booking_new.bundle')}: ${bld.name}`,
                        bundleId: bld.id,
                        id: uniqueId,
                    });
                }
                uniqueId++;
            });
        }
        setAllExpAndBundles(allExp);
    }, [contractExperiences, contractBundleExperiences]);

    useEffect(() => {
        setContract({});
        getUserInfoSync().then(async (usr) => {
            setExperiencerName(usr.experiencer.name);
            await getExperiencesUpdated(usr.experiencer.id);
            await getContracts();
        });
    }, []);

    const handleQuantityChange = (newValue) => {
        setQuantity(newValue);
    };

    const handleDatePickerChange = (date) => {
        setDateDatePicker(date);
        setTimeOfArrival(null);
    };

    useEffect(() => {
        const getCategories = async () => {
            try {
                const categoriesData = await ExperienceResourceService.getResourceCategoryExperience(selectedExperienceItem?.experienceId, { getResources: true });
                if (!categoriesData.resourceCategories) {
                    throw new Error('No se pudieron cargar las categorías');
                }
                const categoriesCopy = categoriesData.resourceCategories.map((item) => ({
                    ...item,
                }));
                setRawDataCategories(categoriesCopy);
                setCategoriesData(categoriesData.resourceCategories);
                return categoriesData;
            } catch (err) {
                console.error(err);
                return false;
            }
        };

        if (selectedExperienceItem) {
            getCategories();
        }
    }, [selectedExperienceItem]);

    return (
        <Layout contentClassName="content">
            <Grid2 container style={{ padding: 25 }}>
                <CheckoutPageComponent
                    categoriesData={categoriesData}
                    totalContracts={contracts}
                    totalItems={allExpAndBundles}
                    contract={contract}
                    handleSelectContract={handleSelectContract}
                    handleClickAvailabilityPopper={handleClickAvailabilityModal}
                    setSelectedExperienceItem={setSelectedExperienceItem}
                    selectedExperienceItem={selectedExperienceItem}
                    handleChangeDetails={handleChangeDetails}
                    onCloseAvailabilityModal={onCloseAvailabilityModal}
                    quantity={quantity}
                    selectedSlot={selectedSlot}
                    translate={translate}
                    setQuantity={setQuantity}
                    addCheckoutItem={addCheckoutItem}
                    checkoutItems={checkoutItems}
                    setCheckoutItems={setCheckoutItems}
                    scheduleDate={scheduleDate}
                    resourceSelected={resourceSelected}
                    addBooking={addBooking}
                    addContractBookingPayment={addContractBookingPayment}
                    deleteContractBookingPayment={deleteContractBookingPayment}
                    cancelStatusPaymentLink={cancelStatusPaymentLink}
                    bookingCode={bookingCode}
                    bookingId={bookingId}
                    setBookingCode={setBookingCode}
                    setBookingId={setBookingId}
                    handleModalSuccess={handleModalSuccess}
                    useAuth={useAuth}
                    rawDataCategories={rawDataCategories}
                    handleClickResourcesModal={handleClickResourcesModal}
                    notifyPaymentLink={notifyPaymentLink}
                    getExperienceTerms={getExperienceTermsId}
                />
            </Grid2>
            <Grid2 container style={{ padding: '2rem' }}>
                <Grid2 size={{ xs: 12, sm: 4, md: 6, lg: 4, xl: 4 }} container>
                    {!selectedExperienceItem && !openAvailabilityModal ? null : (
                        <Grid2 size={12} style={{ marginBottom: '1rem' }}>
                            <AlertDialog
                                open={openAvailabilityModal}
                                handleClose={onCloseAvailabilityModal}
                                dialogTitle=" "
                                labelBack={translate('form.save')}
                                className={classes.modalContent}
                                hideSubmit={true}
                                dialogContent={
                                    <>
                                        <ExperienceAvailabilityLegacy
                                            showLoading={loading}
                                            showPrice={false}
                                            showTitle={false}
                                            showQuantity={true}
                                            quantity={quantity}
                                            datePicker={dateDatePicker}
                                            resources={categoriesData?.length > 0 ? categoriesData : null}
                                            slots={schedule}
                                            experience={selectedExperienceItem}
                                            setQuantity={handleQuantityChange}
                                            setDatePicker={(date) => {
                                                handleDatePickerChange(date);
                                            }}
                                            setVisibleRange={setVisibleRange}
                                            setSelectedSlot={(slot) => {
                                                setSelectedSlot(slot);
                                            }}
                                            setResourceSelected={setResourceSelected}
                                            resourceSelected={resourceSelected}
                                            experienceDetailOptions={experienceDetailOptions}
                                            experienceDetail={experienceDetail?.id}
                                            setExperienceDetail={handleSetExpDetail}
                                        />
                                    </>
                                }
                            />
                        </Grid2>
                    )}
                    {(!selectedExperienceItem && !openResourcesModal) || !categoriesData || !categoriesData.length ? null : <AlertDialog open={openResourcesModal} handleClose={onCloseResourcesModal} dialogTitle=" " labelBack={translate('form.save')} className={classes.modalContent} hideSubmit={true} dialogContent={<ResourceGrid categories={categoriesData} quantity={quantity} setResourceSelected={setResourceSelected} resourceSelected={resourceSelected} />} />}
                </Grid2>
                <Grid2>
                    <AlertDialog
                        open={successOpen}
                        dialogTitle={translate('booking_new.confirmation')}
                        hideTitle={true}
                        dialogContent={`${translate('booking_new.booking_success')} ${bookingCode}`}
                        handleClose={() => {
                            setSuccessOpen(false);
                            const auxCheckout = [];
                            setCheckoutItems(auxCheckout);
                            history.push(ROUTES.BOOKINGS.GLOBAL);
                        }}
                        handleSubmit={() => {
                            setSuccessOpen(false);
                            const auxCheckout = [];
                            setCheckoutItems(auxCheckout);
                            history.push(`${ROUTES.BOOKINGS.GLOBAL}/${bookingId || ''}`);
                        }}
                        labelBack={translate('form.cancel')}
                        hideBack={true}
                        labelNext="Ok"
                    />
                </Grid2>
            </Grid2>
        </Layout>
    );
};

export default BookingNew;
